<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            {{ title }}
          </p>
          <div style="padding-top: 10px">
            <el-tabs type="border-card" @tab-click="HandleTabClick" value="t1">
              <el-tab-pane label="Info" name="t1" ref="t1">
                <div v-if="activetab === 't1'">
                  <OsebniPodatkiInfo/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Soglasja" name="t2" ref="t2" v-if="izbranaStanka !== ''">
                <div v-if="activetab === 't2'">
                  <Soglasja
                    :key="soglasjaKey"
                    @osveziPodatkeStranke="RefreshUserData"
                    :izbranaStanka="izbranaStanka"
                    :id-tip-obvescanja-o-splosnih-pogojih="idTipObvescanjaOSplosnihPogojih" />
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {Select, Option, TabPane, Tabs} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import OsebniPodatkiInfo from './OsebniPodatkiInSoglasja/OsebniPodatkiInfo'
import Soglasja from './OsebniPodatkiInSoglasja/Soglasja'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import {PridobiStranko} from '../../../../assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'


export default {
  name: 'osebniPodatkiInSoglasja',
  mixins: [PrikazVsebine, GetPodatkiIzbirnika, PridobiStranko],
  data () {
    return {
      title: 'Soglasja',
      clientAgent: null,
      activetab: 't1',
      izbranaStanka: '',
      idTipObvescanjaOSplosnihPogojih: 1,
      soglasjaKey: 0
    }
  },
  components: {
    'Soglasja': Soglasja,
    'OsebniPodatkiInfo': OsebniPodatkiInfo,
    'IzbirnikStranke': IzbirnikStranke,
    [Select.name]: Select,
    [Option.name]: Option,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  methods: {
    RefreshUserData () {
      let param = {}
      param.vmesnik = this
      param.filter = {'filter_name': 'id_stranka', 'filter_value': this.izbranaStanka}
      this.PridobiPodatkeIzbirnika(param)
    },
    PrenosniPodatki (stranka) {
      if (stranka.data.length > 0) {
        this.idTipObvescanjaOSplosnihPogojih = Number(stranka.data[0].tipObvescanjaSplosniPogoji)
        this.soglasjaKey++
      }
    },
    GetStranka (podatkiStranke) {
      this.izbranaStanka = podatkiStranke.id_stranka
      this.idTipObvescanjaOSplosnihPogojih = Number(podatkiStranke.tipObvescanjaSplosniPogoji)
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/OsebniPodatkiInSoglasja.vue